"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutTableHorizontalBorder = void 0;
var layout_table_border_1 = require("./layout-table-border");
var LayoutTableHorizontalBorder = (function () {
    function LayoutTableHorizontalBorder() {
    }
    LayoutTableHorizontalBorder.prototype.clone = function () {
        var result = new LayoutTableHorizontalBorder();
        result.copyFrom(this);
        return result;
    };
    LayoutTableHorizontalBorder.prototype.copyFrom = function (obj) {
        this.length = obj.length;
        this.xPosition = obj.xPosition;
        this.borderInfo = obj.borderInfo.clone();
    };
    LayoutTableHorizontalBorder.prototype.getLayoutTableBorder = function (line) {
        return new layout_table_border_1.LayoutTableBorder(this.xPosition, line.yPosition - (line.isOffsetFromTop ? 0 : this.borderInfo.width), this.length, this.borderInfo);
    };
    return LayoutTableHorizontalBorder;
}());
exports.LayoutTableHorizontalBorder = LayoutTableHorizontalBorder;
